import {
  LOAD_TEST_DATA,
  SET_ACTIVE_TEST,
  SET_ACTIVE_RESULT
} from '../actions/client';

// default clientData state
export const initClientData = {
  'testData': {},
  'activeTest': '',
  'activeTestResult': null,
};

// clientData reducer
const clientData = (state, action) => {
  if(state === undefined) {
    return {};
  }
  switch (action.type) {
    case LOAD_TEST_DATA:
      return Object.assign({}, state, {
        testData: action.payload,
      });
    case SET_ACTIVE_TEST:
      return Object.assign({}, state, {
        activeTest: action.payload,
      });
    case SET_ACTIVE_RESULT:
      const result = action.payload;
      return Object.assign({}, state, {
        activeTestResult: result,
      });
    default:
      return state;
  }
};

export default clientData;



// WEBPACK FOOTER //
// ./src/reducers/client.js